import { FC, memo, useMemo } from 'react'
import { GpsSupplyRequest } from './types/types'
import { formatDate, formatDuration, DATE_FORMAT_MASK_WITH_TIME } from 'lib/date'
import { generateGeoJsonUrl } from 'lib/helpers/gpsHelper'

import { ReactComponent as MapIcon } from 'images/icons/location.svg'
import { ReactComponent as BoxIcon } from 'images/icons/box.svg'
import { ReactComponent as CalendarIcon } from 'images/icons/calendar.svg'
import { ReactComponent as ClockIcon } from 'images/icons/clock.svg'

import styles from './GpsPetitionMetadata.module.scss'

type GpsPetitionMetadataProps = {
  petition: GpsSupplyRequest
}

const GpsPetitionMetadata: FC<GpsPetitionMetadataProps> = ({ petition }) => {
  const { center, range_meters } = petition.centerAndRange
  const roundedRange = Math.round(range_meters)

  const geojsonUrl = useMemo(
    () => generateGeoJsonUrl(center.lat, center.long, range_meters, 'GPS Petition Location'),
    [center.lat, center.long, range_meters],
  )

  return (
    <>
      <div className={styles.infoItem}>
        <ClockIcon className={styles.icon} />
        <div aria-label="Mint Window" data-cooltipz-dir="top">
          <strong>Mint Window:</strong> {formatDate(petition.activeFrom, DATE_FORMAT_MASK_WITH_TIME)}
          {' to '}
          {formatDate(petition.activeTo, DATE_FORMAT_MASK_WITH_TIME)}
          <br />
          <strong>Duration:</strong> {formatDuration(petition.duration)}
        </div>
      </div>
      <div className={styles.infoItem}>
        <MapIcon className={styles.icon} />
        <div aria-label="GPS Location" data-cooltipz-dir="top">
          <strong>Coordinates:</strong>{' '}
          <a
            href={geojsonUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#007bff', textDecoration: 'underline' }}
          >
            {center.lat.toFixed(6)}, {center.long.toFixed(6)}
          </a>
          <br />
          <strong>Range:</strong> {roundedRange} meters
        </div>
      </div>

      <div className={styles.infoItem}>
        <BoxIcon className={styles.icon} />
        <div aria-label="Amount Requested" data-cooltipz-dir="top">
          <strong>Amount:</strong> {petition.amount} POAPs
        </div>
      </div>

      <div className={styles.infoItem}>
        <CalendarIcon className={styles.icon} />
        <div aria-label="Created Date" data-cooltipz-dir="top">
          <strong>Created:</strong> {formatDate(petition.createdAt, DATE_FORMAT_MASK_WITH_TIME)}
        </div>
      </div>
    </>
  )
}

export default memo(GpsPetitionMetadata)
